import { PubSub } from "@/shared/utils/pubSub";

type PlaceDefaultAppliedCallback = (fieldPath: string, gpid: string) => void;

/**
 * Neutral pub-sub channel for "PlaceExactness has finished applying the level-based
 * default exactness for a place selection".
 *
 * `PlaceExactness` publishes this in the test arm immediately after it writes the computed
 * default (which happens after an async place-data fetch of unknown duration). The event
 * carries the `fieldPath` and the `gpid` the default was applied for.
 *
 * It exists so downstream reconcilers (e.g. the match-all-terms `useOnPlaceSelection`) can
 * act *after* the default write without having to know how PlaceExactness computes or times
 * that write. The completion event is the explicit contract; consumers no longer depend on
 * PlaceExactness's internal async steps.
 */
export const placeDefaultAppliedPubSub = new PubSub<PlaceDefaultAppliedCallback>();
